import MESSAGES from "@constants/messages.constants";
import { setAlertMessage } from "@reducers/alert.reducer";
import PermissionDeniedComponent from "@screens/permission-denied/permission-denied.component";
import { checkMenuAccess } from "@utils/menu-auth";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { menuUrl } from "../bug-tracker-list/model/bug-tracker-list.constants";
import { createEntry } from "./bug-tracker-create.component.service";
import { getBugFormInputs } from "../model/bug-tracker.modal";
import BugTemplateCreateComponent from "./bug-tracker-create-template.component";
import { useEffect } from "react";
import { getMenusByRole } from "@screens/system/menu-items/menu-items-list/menu-items-list.component.service";
import { getAllUsers } from "@screens/user-administration/notification/notification-create/notification-create.component.service";

const {
  ALERT_TYPES: { SUCCESS, ERROR },
  BUG_ALERTS: { CREATE_ALERT },
} = MESSAGES;

const BugCreateComponent = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const menuAccess = checkMenuAccess(menuUrl, "write");
  const [formInputs, setFormInputs] = useState([]);

  const [formTriggers, setFormTriggers] = useState({
    submitTrigger: 0,
    validationTrigger: 0,
  });

  const handleTriggerClick = (type) => {
    if (type === "SUBMIT") {
      setFormTriggers({
        ...formTriggers,
        submitTrigger: formTriggers.submitTrigger + 1,
      });
    }
  };

  const handleBackClick = () => {
    history.push(`/${menuUrl}`);
  };

  const handleSubmit = async ({ values, errors }) => {
    // INFO : check for errors and return if errors found
    if (errors.length > 0) return;

    // INFO :  construct payload
    let bugPayload = {};
    for (let i = 0; i < values.length; i++) {
      bugPayload[values[i].name] = values[i].value;
    }

    // INFO : call create api
    const bugResponse = await createEntry(bugPayload);

    // INFO : check api response and show relevant alert message
    if (bugResponse.status) {
      dispatch(setAlertMessage({ type: SUCCESS, message: CREATE_ALERT }));
      history.push(`/${menuUrl}`);
    } else {
      dispatch(setAlertMessage({ type: ERROR, message: bugResponse.message }));
    }
  };

  const onLoad = async () => {
    let menuListResponse = [];
    let formatedMenuList = [];
    let formatedUsersList = [];
    let formattedSubMenusList = [];

    menuListResponse = await getMenusByRole();
    console.log({ menuListResponse });
    if (menuListResponse.status) {
      formatedMenuList = menuListResponse.data.map((menu) => {
        return {
          name: menu.menu_name,
          value: menu.menu_id,
        };
      });
    }

    const userResponse = await getAllUsers();
    console.log({ userResponse });
    if (userResponse.status) {
      formatedUsersList = userResponse.data.map((data) => {
        return {
          name: data.name,
          value: data.id,
        };
      });
    }

    menuListResponse.data.forEach((menu) => {
      if (menu.sub_menus && menu.sub_menus.length > 0) {
        menu.sub_menus.forEach((subMenu) => {
          formattedSubMenusList.push({
            name: subMenu.menu_name,
            value: subMenu.menu_id,
          });
        });
      }
    });

    console.log({ formattedSubMenusList });

    const formInputData = getBugFormInputs(
      {},
      formatedMenuList,
      formatedUsersList,
      formattedSubMenusList
    );
    console.log({ formatedMenuList, formInputData });
    setFormInputs(formInputData);
  };

  useEffect(() => {
    onLoad();
  }, []);

  const templateModal = {
    formTriggers,
    formInputs,
  };

  const templateEvents = {
    handleSubmit,
    handleTriggerClick,
    handleBackClick,
  };

  return menuAccess ? (
    <BugTemplateCreateComponent
      templateModal={templateModal}
      templateEvents={templateEvents}
    />
  ) : (
    <PermissionDeniedComponent />
  );
};

export default BugCreateComponent;
